import React, { useContext, useMemo } from 'react';
import TotalSalesStyled from './TotalSalesStyled';
import { Box, useTheme } from '@material-ui/core';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import { LineChart, BarChart } from 'echarts/charts';
import { TitleComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import SvgIcon from '@/components/SvgIconML/SvgIconML';
import { fmtPercent } from '@/utils/comUtil';
import { useSelector } from 'dva';
import { transNum } from '@/utils/comUtil';
import Loading from '@/components/LoadingML/LoadingML';
import NoData from '@/components/no_data_show/NoData';
// import TooltipsML from '@/components/TooltipsML/TooltipsML';
import { fmtThousand } from '@/utils/comUtil';
import { useIntl } from 'umi';
echarts.use([TitleComponent, CanvasRenderer, LineChart, BarChart]);

// 图表容器样式提到模块级，保证引用稳定，
// 避免 ReactEChartsCore 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%', height: '100%' };

const TotalSales = () => {
  const themeContext = useContext(ThemeContext);
  const theme = useTheme();
  const brandContext = useContext(BrandContext);
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { charts } = themeContext[brandContext];
  const intl = useIntl();
  const { formatMessage } = intl;

  // const totalSales = useSelector((state) => state.bhc.BHC_TOTAL_SALES);
  const totalSalesV2 = useSelector((state) => state.bhc.totalSalesV2);
  const BHC_TREND_TARGET_ACHIEVED =
    useSelector((state) => state.bhc.BHC_TREND_TARGET_ACHIEVED) || [];

  const loadingEffect = useSelector((state) => state.loading);
  const salesLoading = loadingEffect.effects['bhc/getTotalSales'];

  const totalSaleTitle = BHC_TREND_TARGET_ACHIEVED[0]?.value * 100;

  const totalSalesData = totalSalesV2.totalSalesAmount;
  const salesIncreaseRate = totalSalesV2.totalSalesAmountYearOverYear;
  const salesNum = totalSalesV2.ticketCnt;
  const salesNumIncreaseRate = totalSalesV2.ticketCntYearOverYear;

  const newMember = totalSalesV2.newMemberRatio;
  const existingMember = totalSalesV2.oldMemberRatio;
  // const nonMember = totalSalesV2.nonMemberRatio;

  // 百分比
  const barNewMemberData = useMemo(() => {
    let data = [];
    data.push(newMember * 100);
    return data;
  }, [newMember]);

  const barExistingMemberData = useMemo(() => {
    let data = [];
    data.push(existingMember * 100);
    return data;
  }, [existingMember]);

  // const barNonMemberData = useMemo(() => {
  //   let data = [];
  //   data.push(nonMember * 100);
  //   return data;
  // }, [nonMember]);

  const reportLoading = loadingEffect.effects['bhc/getTotalSalesReport'];
  const loading = salesLoading || reportLoading;

  const BHC_TREND_ACTUALFIRST = useSelector(
    (state) => state.bhc.BHC_TREND_ACTUALFIRST,
  );
  const BHC_TREND_ACTUALSECOND = useSelector(
    (state) => state.bhc.BHC_TREND_ACTUALSECOND,
  );
  const actualDataSecond = useSelector((state) => state.bhc.actualDataSecond);
  const actualDataFirst = useSelector((state) => state.bhc.actualDataFirst);
  const yearFirst = useSelector((state) => state.bhc.yearFirst);
  const yearSecond = useSelector((state) => state.bhc.yearSecond);

  // const dataLen = BHC_TREND_FORECAST?.length;
  // const forcastData = Array(12 - dataLen).fill('N/A');

  const actualFirst = useMemo(() => {
    const num = Number(BHC_TREND_ACTUALFIRST[0]?.LABEL);
    if (num > 1) {
      const forcastData = Array(num - 1).fill('N/A');
      return forcastData.concat(actualDataFirst);
    }
    return actualDataFirst;
  }, [BHC_TREND_ACTUALFIRST, actualDataFirst]);

  const actualSecond = useMemo(() => {
    const num = Number(BHC_TREND_ACTUALSECOND[0]?.LABEL);
    if (num > 1) {
      const forcastData = Array(num - 1).fill('N/A');
      return forcastData.concat(actualDataSecond);
    }
    return actualDataSecond;
  }, [BHC_TREND_ACTUALSECOND, actualDataSecond]);

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    let option = {
      title: {
        // text: `目标达成率${totalSaleTitle}%`,
        text: Number(totalSaleTitle) ? `目标达成率${totalSaleTitle}%` : '',
        textStyle: {
          fontSize: chartsFontSize.s03,
          color: '#616161',
          fontWeight: 'lighter',
        },
      },
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
        confine: true,
      },
      legend: {
        right: 0,
        orient: 'vertical',
        // data: [
        //   formatMessage({ id: 'ec.dashboard.c02.lbl02' }),
        //   formatMessage({ id: 'ec.dashboard.c02.lbl03' }),
        // ],
        // data:['Actual','2018','ForeCast'],
        data: [
          {
            name: yearFirst,
            itemStyle: {
              // borderType: 'dashed',
            },
          },
          {
            name: yearSecond,
            itemStyle: {
              // borderType: 'dotted',
            },
          },
          //暂时隐藏预测图标
          // {
          //   name: '预测',
          //   itemStyle: {
          //     borderType: 'dotted',
          //   },
          // },
        ],
        // borderDashOffset: 5,
        // itemWidth: 10,
        // itemHeight: 10,
        top: 0,
      },
      grid: {
        top: 35,
        left: 0,
        // right: 96,
        bottom: 0,
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: [
            formatMessage({ id: 'comm.month.lbl.1' }),
            formatMessage({ id: 'comm.month.lbl.2' }),
            formatMessage({ id: 'comm.month.lbl.3' }),
            formatMessage({ id: 'comm.month.lbl.4' }),
            formatMessage({ id: 'comm.month.lbl.5' }),
            formatMessage({ id: 'comm.month.lbl.6' }),
            formatMessage({ id: 'comm.month.lbl.7' }),
            formatMessage({ id: 'comm.month.lbl.8' }),
            formatMessage({ id: 'comm.month.lbl.9' }),
            formatMessage({ id: 'comm.month.lbl.10' }),
            formatMessage({ id: 'comm.month.lbl.11' }),
            formatMessage({ id: 'comm.month.lbl.12' }),
          ],
          axisLine: {
            lineStyle: {
              width: 1.5,
              fontSize: 12,
            },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          show: false,
          axisTick: false,
          axisLine: false,
          axisLabel: {
            color: charts.yColor, //坐标值得具体的颜色
            // color: 'green',
            fontSize: 12,
            // formatter: function (p) {
            //   return fmtThousand(p);
            // },
          },
          splitLine: {
            show: false, //去除网格线
            lineStyle: {
              color: charts.axisLineColor,
              // color: 'green',
            },
          },
          name: '新/活',
          // nameRotate: 45,
          // nameGap: 15,
          nameTextStyle: {
            // color: charts.yColor,
            color: 'green',
          },
          min: 0,
        },
      ],
      color: charts.lineColorList,
      // color: 'green',
      // series: seriesData,
      series: [
        {
          // name: formatMessage({ id: 'ec.dashboard.c02.lbl02' }),
          name: yearSecond,
          type: 'line',
          // data: data[type].newMembers,
          // data: seriesData1,
          smooth: true,
          yAxisIndex: 0,
          lineStyle: {
            width: 2,
          },
          color: '#1D8FC0',
          // color:!yearSecond?'rgb(218,218,218)':'#1D8FC0',
          showSymbol: false,
          emphasis: {
            focus: 'series',
          },
          data: actualSecond,
        },
        {
          // name: formatMessage({ id: 'ec.dashboard.c02.lbl02' }),
          name: yearFirst,
          type: 'line',
          // color: 'rgb(218,218,218)',
          color: !yearSecond ? '#1D8FC0' : 'rgb(218,218,218)',
          smooth: true,
          yAxisIndex: 0,
          lineStyle: {
            width: 2,
          },
          showSymbol: false,
          emphasis: {
            focus: 'series',
          },
          // data: [120, 282, 111, 234, 220, 320],
          data: actualFirst,
        },
        //暂时隐藏预测图标
        // {
        //   // name: formatMessage({ id: 'ec.dashboard.c02.lbl02' }),
        //   name: '预测',
        //   type: 'line',
        //   color: '#FEB6B5',
        //   // data: data[type].newMembers,
        //   // data: seriesData1,
        //   smooth: true,
        //   yAxisIndex: 0,
        //   lineStyle: {
        //     width: 2,
        //     type: 'dashed',
        //   },
        //   showSymbol: false,
        //   emphasis: {
        //     focus: 'series',
        //   },
        //   // eslint-disable-next-line no-sparse-arrays
        //   data: forcastData.concat(BHC_TREND_FORECAST),
        // },
      ],
    };
    return option;
  }, [
    actualFirst,
    actualSecond,
    charts.axisLineColor,
    charts.lineColorList,
    charts.yColor,
    chartsFontSize.s03,
    fontFamily,
    formatMessage,
    totalSaleTitle,
    yearFirst,
    yearSecond,
  ]);

  // 监听图表变化
  const barChartOption = useMemo(() => {
    let option = {
      tooltip: {
        // trigger: 'axis',
        // triggerOn: false,
        show: false,
        // axisPointer: {
        //   // Use axis to trigger tooltip
        //   type: 'shadow',
        // },
      },
      // legend: {},
      grid: {
        left: '0%',
        right: '0%',
        top: '0%',
        // bottom: '95%',
        // containLabel: true,
        width: '100%',
        // width: '580',
        // height: 9,
        height: '100%',
      },
      xAxis: {
        type: 'value',
        show: false,
        max: 100,
      },
      yAxis: {
        show: false,
        type: 'category',
        data: ['Mon'],
      },
      series: [
        {
          name: 'Direct',
          type: 'bar',
          stack: 'total',
          label: {
            show: false,
          },
          emphasis: {
            focus: 'series',
          },
          data: barNewMemberData,
          color: '#1D8FC0',
          itemStyle: {
            borderRadius: [6, 0, 0, 6],
            // borderRadius: barNonMemberData[0] > 0 ? [6, 0, 0, 6] : [6, 6, 6, 6],
          },
        },
        {
          name: 'Mail Ad',
          type: 'bar',
          stack: 'total',
          label: {
            show: false,
          },
          emphasis: {
            focus: 'series',
          },
          data: barExistingMemberData,
          color: '#9E9E9E',
          itemStyle: {
            borderRadius: [0, 6, 6, 0],
          },
        },
        // {
        //   name: 'Affiliate Ad',
        //   type: 'bar',
        //   stack: 'total',
        //   label: {
        //     show: false,
        //   },
        //   emphasis: {
        //     focus: 'series',
        //   },
        //   data: barNonMemberData,
        //   color: '#9E9E9E',
        //   itemStyle: {
        //     // borderRadius: [0, 6, 6, 0],
        //     borderRadius: barNewMemberData[0] > 0 ? [0, 6, 6, 0] : [6, 6, 6, 6],
        //   },
        // },
      ],
    };
    return option;
  }, [barExistingMemberData, barNewMemberData]);

  return (
    <TotalSalesStyled theme={theme}>
      {/* 左侧数据展示 */}
      <Loading loading={loading}>
        <div className="sales-data-wrap">
          <Box className="sales-left">
            <div className="sales-top-wrap">
              <div className="sales-icon-wrap">
                <SvgIcon name="shopping" size={22} color="#1565C0" />
                <div className="sales-icon-wrap-num">
                  {/* 总销售额 */}
                  {formatMessage({ id: 'report.health.n03.lbl01' })}
                  {/* <TooltipsML
                    isAbsolute={true}
                    left={'60px'}
                    top={'-4px'}
                    // title={'产品大类为鞋和配件的购买金额'}
                    title={formatMessage({ id: 'report.health.n03.tip07' })}
                  ></TooltipsML> */}
                </div>
              </div>
              <div className="sales-evol-wrap">
                <div className="sales-evol-wrap-top">
                  <div className="amount-tag-wrap">
                    <span className="amount-tag-rmb">¥</span>
                    <span className="amount-tag">
                      {transNum(totalSalesData)}
                      {/* <TooltipsML
                        isAbsolute={true}
                        right={'-10px'}
                        top={'-13px'}
                        // title={
                        //   '当数值整数部分大于3位数时，用K,M,B缩小方式显示，K=1,000,M=1,000,000,B=1,000,000,000，小数部分保留2位，四舍五入'
                        // }
                        title={formatMessage({ id: 'report.health.n03.tip03' })}
                      ></TooltipsML> */}
                    </span>
                  </div>
                  <div className="amount-content-wrap">
                    <span className="amount-evol">
                      {/* 同比 */}
                      {formatMessage({ id: 'report.health.n03.lbl04' })}
                      {/* <TooltipsML
                        // title={
                        //   '（当年数值-去年数值）/去年数值。特殊约定：当年为2021年时，去年为2019年'
                        // }
                        title={formatMessage({ id: 'report.health.n03.tip05' })}
                      ></TooltipsML> */}
                    </span>
                    <span
                      className={
                        salesIncreaseRate >= 0 ? 'percent-up' : 'percent-down'
                      }
                    >
                      {fmtPercent(salesIncreaseRate, 2)}
                      {salesIncreaseRate ? (
                        <SvgIcon
                          name={
                            salesIncreaseRate >= 0 ? 'numberUp' : 'numberDown'
                          }
                          size={11}
                          color="#1565C0"
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
                <div className="sales-evol-wrap-top">
                  <div className="amount-tag-wrap-bottom">
                    <span className="amount-paa">
                      {/* 双数 */}
                      {formatMessage({ id: 'report.health.n03.lbl06' })}
                      {/* <TooltipsML
                        isAbsolute={true}
                        // title={'产品大类为鞋的件数'}
                        title={formatMessage({ id: 'report.health.n03.tip07' })}
                        right={'-13px'}
                        top={'-4px'}
                      ></TooltipsML> */}
                    </span>
                    <span className="amount-paa-num">
                      {fmtThousand(salesNum)}
                    </span>
                  </div>

                  <div className="amount-content-wrap">
                    <span className="amount-evol">
                      {/* 同比 */}
                      {formatMessage({ id: 'report.health.n03.lbl04' })}
                    </span>
                    <span
                      className={
                        salesNumIncreaseRate >= 0
                          ? 'percent-up'
                          : 'percent-down'
                      }
                    >
                      {fmtPercent(salesNumIncreaseRate, 2)}
                      {salesNumIncreaseRate ? (
                        <SvgIcon
                          name={
                            salesNumIncreaseRate >= 0
                              ? 'numberUp'
                              : 'numberDown'
                          }
                          size={11}
                          color="#1565C0"
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* 进度条占比 */}
            <Box className="sales-bottom-wrap">
              <div className="member-percent">
                <span style={{ color: '#1D8FC0' }}>
                  <div>
                    {/* 新会员 */}
                    {formatMessage({ id: 'report.health.n03.lbl09' })}
                  </div>
                  {fmtPercent(newMember, 2)}
                </span>
                <span style={{ color: '#9E9E9E' }}>
                  <div>
                    {/* 老会员 */}
                    {formatMessage({ id: 'report.health.n03.lbl10' })}
                  </div>
                  {fmtPercent(existingMember, 2)}
                </span>
                {/* 非会员 */}
                {/* <span style={{ color: '#9E9E9E' }}>
                  <div>
                    {formatMessage({ id: 'report.health.n03.lbl11' })}
                  </div>
                  {fmtPercent(nonMember, 2)}
                </span> */}
              </div>
              {/* 进度条 */}
              <Box className="progress-wrap">
                <ReactEChartsCore
                  echarts={echarts}
                  lazyUpdate={true}
                  option={barChartOption}
                  notMerge={true}
                  style={CHART_STYLE}
                />
                {/* <TooltipsML
                  // title={'销售额占比'}
                  title={formatMessage({ id: 'report.health.n03.tip12' })}
                ></TooltipsML> */}
              </Box>
            </Box>
          </Box>
          {/* 右侧echarts */}
          <Box className="sales-right" id="rightEcharts">
            {loading ||
            BHC_TREND_ACTUALFIRST?.length > 0 ||
            BHC_TREND_ACTUALSECOND?.length > 0 ? (
              <>
                {/* <TooltipsML
                  isAbsolute={true}
                  // title={'按12个月展示销售额的趋势'}
                  title={formatMessage({ id: 'report.health.n03.tip13' })}
                  left={'56px'}
                  top={0}
                ></TooltipsML> */}
                <ReactEChartsCore
                  echarts={echarts}
                  lazyUpdate={true}
                  option={chartOption}
                  notMerge={true}
                  style={CHART_STYLE}
                />
              </>
            ) : (
              // </Loading>
              <NoData loading={loading} />
            )}
          </Box>
        </div>
      </Loading>
    </TotalSalesStyled>
  );
};

export default TotalSales;
